var React = require('react');

function CaretRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 16L9 9L2 2","stroke":"#D4D4E0","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CaretRight.defaultProps = {"width":"11","height":"18","viewBox":"0 0 11 18","fill":"none"};

module.exports = CaretRight;

CaretRight.default = CaretRight;
